// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"52a1c830","815":"3dee4d3a"}[chunkId] + ".chunk.js";
};